/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-form-field-label-wrapper .mat-form-field-label .mat-placeholder-required.mat-form-field-required-marker{color:transparent}"];
export { styles as styles };
